import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MDIconComponent, MDToolTipDirective } from '@melodic-ui/components';

@Component({
	selector: 'lb-sortable-header',
	standalone: true,
	imports: [MDIconComponent, MDToolTipDirective],
	templateUrl: './sortable-header.component.html',
	styleUrl: './sortable-header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SortableHeaderComponent {
	/** Display label for the column header. */
	label = input.required<string>();

	/** Optional explainer shown on hover, for columns whose label can't carry the caveat. Empty = none. */
	tooltip = input<string>('');

	/** The sort key for this column. Null means not sortable. */
	sortKey = input<string | null>(null);

	/** Whether this column supports sorting. */
	isSortable = input(false);

	/** The currently active sort key from the parent. */
	activeSortBy = input<string | null>(null);

	/** The currently active sort order from the parent. */
	activeSortOrder = input<'asc' | 'desc'>('desc');

	/** Callback for use with ngComponentOutlet (which cannot bind outputs). */
	onSortFn = input<(() => void) | null>(null);

	/** Emitted when the user clicks to sort this column. */
	sort = output<void>();

	isActive = computed(() => this.sortKey() !== null && this.activeSortBy() === this.sortKey());
	showAsc = computed(() => this.isActive() && this.activeSortOrder() === 'asc');
	showDesc = computed(() => this.isActive() && this.activeSortOrder() === 'desc');
	showNeutral = computed(() => !this.isActive() && this.isSortable());

	onSort(): void {
		if (this.isSortable()) {
			const fn = this.onSortFn();
			if (fn) fn();
			this.sort.emit();
		}
	}
}
